import {http} from "Services/Http/HttpClient";

export const getCourseLevels = async() : Promise<unknown> => {
    return await http.get('course-levels')
}